module.exports = __webpack_public_path__ + "img/icon-logo.f3f30865.png";